module.exports = __webpack_public_path__ + "img/org-admin.6ce44ad3.svg";